enum SystemOfUnits {
	Metrical = 'metrical',
	Imperial = 'imperial'
}

export default SystemOfUnits;
